import { SidebarCustomComponents } from './domain/constants/sidebar-custom-components';
import { SidebarView as PublicSidebarView, SidebarCustomCommandProps } from './domain/models/sidebar.models';
import { SidebarPublicPort } from './infrastructure/public/public.port';
import { CloseSidebarCustom, LoadSidebar } from './infrastructure/state/sidebar.actions';
import { sidebarStatus, viewCart } from './infrastructure/state/sidebar.selectors';

export { SidebarPublicPort };

export { RegisterSidebarCustomComponent, UnregisterSidebarCustomComponent } from './domain/constants/sidebar-custom-components';

export const SidebarSelectors = {
    sidebarStatus,
    viewCart,
};

export const SidebarPublicModels = {
    view: PublicSidebarView,
    sidebarCustomComponents: SidebarCustomComponents,
};

export const SidebarPublicActions = {
    LoadSidebar,
    CloseSidebarCustom,
};

export { LoadSidebarCommand } from './infrastructure/commands/sidebar.command';
export { SidebarPopupEffects } from './infrastructure/public/sidebar-popup.effects';

export type PublicSidebarCustomCommandProps = SidebarCustomCommandProps;

export { SidebarPortInterface } from './domain/ports/primary/sidebar.port';
